<div class="item-header">
    @if (!!label) {
        <span [class]="`label small-padding ${ label }`">{{ 'COMPONENTS.WIDGET_PICKER.LABEL.' + label | translate }}</span>
    }
    <span class="item-actions">
        <ng-content select="[action]" />
    </span>
</div>

<div class="item-image">
    @if (thumbnailImg && thumbnailImg.endsWith('svg')) {
        <svg-icon
            class="svg-icon height-100"
            [src]="thumbnailImg"
            [svgStyle]="{ fill: (defaultFillerColor$ | async), height: '100%', width: '100%' }"
        />
    } @else {
        <img class="height-100" [src]="thumbnailImg || defaultImage" />
    }
</div>

<div ellipsisWithTitleFallback class="bold-text">{{ title }}</div>
